import { render, staticRenderFns } from "./ContentSwitcher.vue?vue&type=template&id=1845e3a4&scoped=true"
import script from "./ContentSwitcher.vue?vue&type=script&lang=js"
export * from "./ContentSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ContentSwitcher.vue?vue&type=style&index=0&id=1845e3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845e3a4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default})
